import * as yup from "yup";
import { TFunction } from "i18next";

import { TPositionFormItem } from "./types";

export const getEmployeeProfileValidation = (t: TFunction) => {
  const required = t("validation.required");
  const invalidEmail = t("validation.invalid_email");

  const requiredDate = yup
    .date()
    .nullable()
    .typeError(required)
    .required(required);

  const emailSchema = (isRequired: boolean) =>
    isRequired
      ? yup.string().required(required).email(invalidEmail)
      : yup
          .string()
          .test("email-format", invalidEmail, (value) =>
            !value ? true : yup.string().email().isValidSync(value),
          );

  return yup.object().shape({
    surname: yup.string().required(required),
    name: yup.string().required(required),
    gender: yup.string().required(required),
    birthDay: requiredDate,
    hiredDate: requiredDate,
    ladaAcademiaId: yup.string().required(required),
    workPhone: yup.string().required(required),
    positions: yup.array().of(
      yup.lazy((position: TPositionFormItem | undefined) => {
        const isMain = position?.number === "one";
        const hasPosition = Boolean(position?.position?.value);
        const dealerRequired = isMain || hasPosition;
        const dealer = position?.dealers?.[0];
        const isVerified = dealer?.status === "verified";
        const isFired = Boolean(
          dealer?.endDate &&
          (dealer.endOrderNumber || "").trim() &&
          dealer?.dismissalOrderId,
        );
        const positionOrderRequired = dealerRequired && !isVerified && !isFired;

        return yup.object().shape({
          dealers: yup.array().of(
            yup.object().shape({
              dealer: dealerRequired
                ? yup.object().nullable().required(required)
                : yup.object().nullable(),
              email: emailSchema(dealerRequired && !isVerified),
              dataConsentId: dealerRequired
                ? yup.string().required(required)
                : yup.string(),
              startDate: dealerRequired ? requiredDate : yup.date().nullable(),
              startOrderNumber: dealerRequired
                ? yup.string().required(required)
                : yup.string(),
              positionOrderId: positionOrderRequired
                ? yup.string().required(required)
                : yup.string(),
              // TODO PASDILER-2428: обязательная валидация скрытого приказа на увольнение отключена до завершения работ в feat/PASDILER-1829. https://task.sotl.group:8443/browse/PASDILER-2428
              dismissalOrderId: yup.string(),
            }),
          ),
        });
      }) as unknown as yup.AnySchema,
    ),
  });
};
